import React from 'react';
import PropTypes from 'prop-types';
import { OrderView } from '../../../orders/order';

export default class MachineInformationComponent extends React.PureComponent {
  static propTypes = {
    order: PropTypes.instanceOf(OrderView).isRequired,
  };

  render() {
    const { order } = this.props;
    const { machine } = order;
    return (
      <div className="col">
        <div className="card mb-4 box-shadow machine-info h-100">
          <div className="card-body">
            <h6 className="card-title text-center">Machine Information</h6>
            <div className="row">
              <div className="col-sm-12">
                {machine.make}&nbsp;{machine.model}
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12">
                <div>{machine.carrierName}</div>
                <div>
                  {machine.weightClassLabel} ({machine.weightClassDescription})
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
